module.exports = __webpack_public_path__ + "assets/HarmonicMeanDetailed.228c7354411bf1166c7ecedc26c04696.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/HarmonicMeanDetailed.png
// module id = 518
// module chunks = 0